import { render, staticRenderFns } from "./SalesStats.vue?vue&type=template&id=3e8a9880&"
import script from "./SalesStats.vue?vue&type=script&lang=js&"
export * from "./SalesStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports